import { IFollowUpSurveyForList } from '@nkr/models/index';
import { FollowUpSurveyListType } from '@nkr/enums/index';
import { AdminGridWrapper } from '../../styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';
import { SurveyAction } from './survey-action';

interface IProps {
    centerId: number,
    listType: FollowUpSurveyListType,
    list: IFollowUpSurveyForList[],
    isLoading: boolean,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onItemSelected: (id: number, action: SurveyAction) => void
}

const AdminSurveyList = (props: IProps) => {
    return (
        <AdminGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                listType={props.listType}
                centerId={props.centerId}
                isAdmin={true}
                isAdminLogin={true}
                isLoading={props.isLoading}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
                onItemSelected={props.onItemSelected}
            />
        </AdminGridWrapper>
    );
}

export default AdminSurveyList;